import { useState, useRef, useEffect } from 'react'
import { FaChevronDown } from 'react-icons/fa'
import { useParams } from 'react-router-dom'
const CitySelector = ({ cities = [], selectedCity, onCityChange }) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [filteredCities, setFilteredCities] = useState(cities)
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)
  const cityURL = useParams()
  useEffect(() => {
    setFilteredCities(
      cities.filter(city =>
        city.toLowerCase().includes(searchTerm.toLowerCase())
      )
    )
  }, [searchTerm, cities])

   useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])
  return (
    <div className='relative w-full sm:max-w-[220px] max-w-[180px]' ref={dropdownRef}>
       <div
        className='border border-gray-300 rounded-[5px] px-3 py-2 flex justify-between items-center cursor-pointer bg-white capitalize'
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{cityURL.handle || 'Select City'}</span>
        <FaChevronDown className='text-gray-500' />
      </div>

       {isOpen && (
        <div className='absolute left-0 w-full mt-1 border border-gray-300 bg-white rounded-b-[5px] shadow-md z-50'>
           <input
            type='text'
            placeholder='Search city...'
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            className='w-full px-[10px] py-[7px] border-b border-gray-300 focus:outline-none'
          />

          {/* City List */}
          <ul className='max-h-[350px] overflow-auto'>
            {filteredCities.length > 0 ? (
              filteredCities.map((city, index) => (
                <li
                  key={index}
                  className={`px-[10px] py-[6px] cursor-pointer hover:bg-[#f7f7f7] hover:text-black text-[15px] capitalize ${
                    city === selectedCity ? 'bg-[#f48533] text-white' : ''
                  }`}
                  onClick={() => {
                    onCityChange(city)
                    setSearchTerm('')
                    setIsOpen(false)
                  }}
                >
                  {city.charAt(0).toUpperCase() + city.slice(1)}
                </li>
              ))
            ) : (
              <li className='px-[10px] py-[7px] text-gray-500'>
                No results found
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  )
}

export default CitySelector
